const looseUuid = /^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i

export const isUUID = value => {
  if ( ! value || typeof value !== 'string' ) {
    return false
  }

  return looseUuid.test(value)
}

export const safeUUID = value => {
  // skip empty/nullish
  if ( ! value || value === 'null' || value === null || value === 'undefined' || typeof value === undefined ) {
    return null
  }

  // validate via isUUID
  if ( ! isUUID(value) ) {
    console.warn('Invalid UUID format:', value)
    return null
  }

  return value
}